var map = {
	"./base-init.conf.ts": 11828,
	"./baseConfiguration.ts": 53693,
	"./baseSelectorConfiguration.ts": 27186,
	"legacy/customer/base/orpea/base-init.conf.ts": 11828,
	"legacy/customer/base/orpea/baseConfiguration.ts": 53693,
	"legacy/customer/base/orpea/baseSelectorConfiguration.ts": 27186
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59885;